import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPlayStyle0 = cosmosIconCss;

const CosmosIconPlay = /*@__PURE__*/ proxyCustomElement(class CosmosIconPlay extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c2af3981d96d1af660742777da99460909158d56', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cc29f9ec24f4eee79a0ffa73698b093c54dec5f4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9c300145cab0eb66539f172f72ffe1eb0d2d8b50', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.22 17.44 10.38-5.905a.608.608 0 0 0 .283-.531.607.607 0 0 0-.282-.531L7.22 4.568a.426.426 0 0 0-.495.023.615.615 0 0 0-.225.52v11.81a.618.618 0 0 0 .239.492.434.434 0 0 0 .48.027Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPlayStyle0; }
}, [1, "cosmos-icon-play", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-play"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-play":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPlay);
            }
            break;
    } });
}

export { CosmosIconPlay as C, defineCustomElement as d };
